module.exports = __webpack_public_path__ + "static/img/login-pattern1.cc4f5a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-pattern1.svg
// module id = QWj2
// module chunks = 1